var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-caption"},[_c('router-link',{staticClass:"waves-effect waves-light btn-large brand-font",attrs:{"tag":"button","to":{ name: 'lander', params: { slug: _vm.slug }}}},[_vm._v(_vm._s(_vm.label))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }